import React, { useState, useEffect, useRef } from 'react';
import { TERMINAL_COMMANDS } from '../data';

export default function EasterEggTerminal() {
  const [open, setOpen] = useState(false);
  const [lines, setLines] = useState([
    { type: 'system', text: "Mekhal's Terminal v1.0 — Type 'help' for commands. Press Esc or '/' to close." },
  ]);
  const [input, setInput] = useState('');
  const inputRef = useRef(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    const handleKey = (e) => {
      // Don't trigger if user is typing in an input/textarea
      if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') return;
      if (e.key === '/') {
        e.preventDefault();
        setOpen(o => !o);
      }
      if (e.key === 'Escape' && open) {
        setOpen(false);
      }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [open]);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [lines]);

  const execute = (cmd) => {
    const trimmed = cmd.trim().toLowerCase();
    const newLines = [...lines, { type: 'input', text: `> ${cmd}` }];

    if (trimmed === 'clear') {
      setLines([{ type: 'system', text: "Terminal cleared. Type 'help' for commands." }]);
      setInput('');
      return;
    }

    if (trimmed === 'exit') {
      setOpen(false);
      setInput('');
      return;
    }

    if (TERMINAL_COMMANDS[trimmed]) {
      newLines.push({ type: 'output', text: TERMINAL_COMMANDS[trimmed] });
    } else if (trimmed === '') {
      // do nothing
    } else {
      newLines.push({ type: 'error', text: `Command not found: '${trimmed}'. Type 'help' for available commands.` });
    }

    setLines(newLines);
    setInput('');
  };

  if (!open) return null;

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 2500,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(4px)',
    }}
      onClick={(e) => { if (e.target === e.currentTarget) setOpen(false); }}
    >
      <div style={{
        width: 'min(680px, 90vw)', maxHeight: '70vh',
        background: '#0a0a0a', border: '1px solid rgba(232,197,71,0.2)',
        boxShadow: '0 24px 80px rgba(0,0,0,0.6)',
        display: 'flex', flexDirection: 'column',
        fontFamily: 'var(--font-mono)',
      }}>
        {/* Title bar */}
        <div style={{
          padding: '10px 16px', borderBottom: '1px solid rgba(250,250,248,0.08)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        }}>
          <div style={{ display: 'flex', gap: '6px' }}>
            <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#ff5f57' }} />
            <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#febc2e' }} />
            <div style={{ width: '10px', height: '10px', borderRadius: '50%', background: '#28c840' }} />
          </div>
          <div style={{ fontSize: '10px', letterSpacing: '0.2em', color: 'rgba(250,250,248,0.3)', textTransform: 'uppercase' }}>
            mekhal@portfolio ~ %
          </div>
          <button onClick={() => setOpen(false)} style={{ background: 'none', border: 'none', color: 'rgba(250,250,248,0.3)', cursor: 'pointer', fontSize: '12px' }}>ESC</button>
        </div>

        {/* Output area */}
        <div style={{
          flex: 1, overflowY: 'auto', padding: '16px',
          minHeight: '200px', maxHeight: '400px',
        }}>
          {lines.map((line, i) => (
            <div key={i} style={{
              fontSize: '12px', lineHeight: 1.7, marginBottom: '4px',
              color: line.type === 'system' ? 'rgba(250,250,248,0.35)'
                : line.type === 'input' ? '#e8c547'
                : line.type === 'error' ? '#ff6b6b'
                : 'rgba(250,250,248,0.75)',
              whiteSpace: 'pre-wrap',
            }}>
              {line.text}
            </div>
          ))}
          <div ref={bottomRef} />
        </div>

        {/* Input */}
        <div style={{
          padding: '12px 16px', borderTop: '1px solid rgba(250,250,248,0.08)',
          display: 'flex', alignItems: 'center', gap: '8px',
        }}>
          <span style={{ color: '#e8c547', fontSize: '12px' }}>{'>'}</span>
          <input
            ref={inputRef}
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter') execute(input); }}
            style={{
              flex: 1, background: 'transparent', border: 'none', outline: 'none',
              color: 'rgba(250,250,248,0.9)', fontSize: '12px',
              fontFamily: 'var(--font-mono)',
            }}
            placeholder="Type a command..."
            autoFocus
          />
        </div>
      </div>
    </div>
  );
}
